import { render, staticRenderFns } from "./image-item.vue?vue&type=template&id=55eb9b18&"
import script from "./image-item.vue?vue&type=script&lang=js&"
export * from "./image-item.vue?vue&type=script&lang=js&"
import style0 from "./image-item.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports